// extracted by mini-css-extract-plugin
export default {"primary-color":"#006266","secondaryColor":"#ff8945","container":"welcome_page_container__q9Gh9"};